import { __assign, __rest } from "tslib";
import React from 'react';
import MeasuredGrid from './MeasuredGrid';
import { adjustBreakpointHeight, DEFAULT_BREAKPOINTS } from './breakpoints';
export var StandardGrid = function (_a) {
    var _b = _a.adjustHeight, adjustHeight = _b === void 0 ? 0 : _b, children = _a.children, props = __rest(_a, ["adjustHeight", "children"]);
    return (React.createElement(MeasuredGrid, __assign({}, props, { breakpoints: adjustHeight
            ? adjustBreakpointHeight(DEFAULT_BREAKPOINTS, adjustHeight)
            : DEFAULT_BREAKPOINTS, renderElement: children })));
};
export default StandardGrid;
//# sourceMappingURL=StandardGrid.js.map